<template>
  <path
    d="M11 5.00024V16.1702L6.12 11.2902C5.73 10.9002 5.09 10.9002 4.7 11.2902C4.31 11.6802 4.31 12.3102 4.7 12.7002L11.29 19.2902C11.68 19.6802 12.31 19.6802 12.7 19.2902L19.29 12.7002C19.68 12.3102 19.68 11.6802 19.29 11.2902C18.9 10.9002 18.27 10.9002 17.88 11.2902L13 16.1702V5.00024C13 4.45024 12.55 4.00024 12 4.00024C11.45 4.00024 11 4.45024 11 5.00024Z"
  />
</template>
